// extracted by mini-css-extract-plugin
module.exports = {"popup":"floating-tooltip_popup__vhqs0 themeLight","hasMinimumWidth":"floating-tooltip_hasMinimumWidth__x0D8r","arrow":"floating-tooltip_arrow__tAgu_"};